import { Component, Inject, Input, OnDestroy, OnInit, Optional, ViewChild, input } from '@angular/core';
import { NgForm } from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { hasDividends } from '../shares.service';
import { CompaniesService } from '../../companies/companies.service';

@Component({
  selector: 'share-modify',
  standalone: false,
  templateUrl: './modify.component.html',
  styleUrl: './modify.component.scss'
})
export class ShareModifyComponent implements OnInit, OnDestroy {

  @ViewChild('modifyForm', { static: true }) modifyForm: NgForm | undefined
  errorMessage!: string

  public share: any
  public companies: any[] | undefined

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ShareModifyComponent>,
    private companyService: CompaniesService
  ) {
    console.error('ShareModifyComponent -> constructor', data)
    this.share = { ...data, dividends: hasDividends(data) }
  }

  async ngOnInit(): Promise<void> {
    console.error('ShareModifyComponent -> ngOnInit')

    this.companies = await this.companyService.loadOptions()
    console.error('ShareCreateComponent -> ngAfterViewInit', 'companies', this.companies)
  }

  ngOnDestroy(): void {
    console.warn('ShareModifyComponent -> ngOnDestroy')
  }

  onSubmit(): void {
    console.error('ShareModifyComponent -> onSubmit', this.modifyForm?.value);

    if (this.modifyForm?.valid)
      this.dialogRef.close({
        data: {
          response: 'Share modified!',
          values: { ...this.share }
        }
      })
    else
      this.errorMessage = "Errorrrrr"
  }
}
